module.exports = __webpack_public_path__ + "static/media/Fitmonkie_2_Zeal Woven Back Bra.5f9935eb.jpeg";